module.exports = __webpack_public_path__ + "img/saveMap.8e34331b.svg";